// extracted by mini-css-extract-plugin
export default {"spinner":"loadingspinner_spinner__2Prxs"};